import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/pythagorean-theorem-calculator',
  component: () => import('../../routes/PythagoreanTheoremCalculator.svelte'),
  card: {
    id: 'pythagorean-theorem-calculator',
    title: 'Pythagorean Theorem Calculator',
    description:
      "Calculate the missing side of a right triangle using a² + b² = c². Solves for the hypotenuse or either leg and reports the triangle's angles, area, perimeter, inradius, and circumradius.",
    icon: 'calculate',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/pythagorean-theorem-calculator',
    category: 'Conversion & Math',
  },
  seo: {
    title: 'Pythagorean Theorem Calculator – a² + b² = c²',
    description:
      "Free Pythagorean Theorem calculator. Solve for the hypotenuse or either leg of a right triangle using a² + b² = c². Also reports the triangle's angles, area, perimeter, inradius, and circumradius.",
  },
};

export default meta;
